var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgC1RollerShutterGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.09 26h39.82l-4.81 6h-40l4.99-6zm-5 16h40l4.81-6H13.09l-5 6zm0 10h40l4.81-6H13.09l-5 6zm0 10h40l4.81-6H13.09l-5 6zm46-30h10l4.81-6H58.09l-4 6zm0 10h10l4.81-6H58.09l-4 6zm0 10h10l4.81-6H58.09l-4 6zm14.82-36H29.09l-5 6h40l4.82-6z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/C1_Roller_shutter_group.254594e1.svg";
export { SvgC1RollerShutterGroup as ReactComponent };